import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a5f78518&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=a5f78518&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f78518",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\projects\\web_h5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5f78518')) {
      api.createRecord('a5f78518', component.options)
    } else {
      api.reload('a5f78518', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a5f78518&scoped=true", function () {
      api.rerender('a5f78518', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/P3_Page/UserAgreement/index.vue"
export default component.exports